import { images } from 'app/design/images';
import { Column } from 'app/design/primitives/box';
import { View } from 'react-native';
import { useState } from 'react';
import { PCImage } from 'app/design/primitives/image';
import { Gradient } from 'app/design/primitives/gradient';

export function InviteHeaderImage() {
  const [imageHeight, setImageHeight] = useState<number>();
  return (
    <Column style={{ top: -60 }}>
      <PCImage
        aspectRatio={750 / 484}
        onLayout={(event) => setImageHeight(event.nativeEvent.layout.height)}
        source={images.inviteHeader}
        style={{ position: 'absolute', left: 0, right: 0 }}
      />
      <View style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
        <Gradient from="white" fromOpacity={0.6} style={{ height: imageHeight }} to="white" />
      </View>
    </Column>
  );
}
